import React from "react";
import { useLang } from "../context/LanguageContext";
import { SEO } from "../components/SEO";
import { PageHeader } from "../components/PageHeader";
import { Ecosystem } from "../components/home/Ecosystem";
import { Process } from "../components/home/Process";
import { FinancialBenefits, CTASection } from "../components/home/FinancialBenefits";

export default function InvestmentModel() {
  const { t } = useLang();
  return (
    <>
      <SEO pageKey="investment-model" title={t.seo.investmentModel.title} description={t.seo.investmentModel.description} />
      <PageHeader pageKey="investment-model"
        overline={t.ecosystem.overline}
        title={t.ecosystem.title}
        sub={t.about.intro}
        image="https://images.pexels.com/photos/11987205/pexels-photo-11987205.jpeg?auto=compress&w=2000"
      />
      <Ecosystem />
      <FinancialBenefits />
      <Process />
      <CTASection />
    </>
  );
}
